import React, { useState, useEffect, useMemo, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  MenuItem,
  Tooltip,
  TextField,
} from '@material-ui/core';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import DateFnsUtils from '@date-io/date-fns';
import esLocale from 'date-fns/locale/es'

import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

import { useTable, useExpanded } from "react-table";

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import '../../styles/style.scss';

import AdvancesInvoicesAndComplementsService from "../../services/advances-invoices-and-complements.service";

import { convertDateToJulian } from '../../constants/component/convertDateToJulian';
import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";
import usersService from '../../services/users.service';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';


export const AdvancesInvoicesAndComplementsScreen = (props) => {

  const { isLoggedIn, user } = useSelector(state => state.auth);
  const an8Logged = isLoggedIn ? user.noCustomer : '---';

  const currencySelected = 'es-Mx';

  const dateMin = new Date();

  const [selectStartDate, handleStartDateChange] = useState(dateMin);
  const [selectEndDate, handleEndDateChange] = useState(dateMin);

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const redirectLoad = location.state && location.state?.reloadFilters ? location.state : null;

  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const [dataFilters, setDataFilters] = useState({
    an8: '',
    typeOfReceipt: '',
    series: ''
  });

  const [customers, setCustomers] = useState({
    isLoading: true,
    isDisabled: true,
    data: []
  });

  const [saleOrder, setSaleOrder] = useState([]);
  const saleOrderRef = useRef();

  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isSubmitingData, setIsSubmitingData] = useState(false);

  const [errorResponse, setErrorResponse] = useState('');
  const [isErrorResponse, setIsErrorResponse] = useState(false);
  const [isDownloadFile, setIsDownloadFile] = useState(false);
  saleOrderRef.current = saleOrder;

  const validationSchema = Yup.object().shape({
    an8: Yup.string().required('valor requerido').nullable(),
    startDate: Yup.date().default(selectStartDate).required('valor requerido'),
    endDate: Yup.date().default(selectEndDate).required('valor requerido')
      .min(selectStartDate ? selectStartDate : dateMin)
  });

  const {
    register,
    control,
    handleSubmit,
    getValues,
    setValue,
    reset
  } = useForm({
    resolver: yupResolver(validationSchema),
    
  });

  useEffect(() => {
    getCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (redirectLoad?.reloadFilters && isFirstLoad) {
      const params = JSON.parse(localStorage.getItem('headerFilter'));
      const dataTransform = {
        ...params,
        startDate: new Date(params.startDateDefault),
        endDate:  new Date(params.endDateDefault)
      }
      setValue('an8', params.an8);
      setValue('startDate', new Date(params.startDate));
      setValue('endDate', new Date(params.endDate));
      handleStartDateChange(dataTransform.startDate);
      handleEndDateChange(dataTransform.endDate);
      setDataFilters(dataTransform);
      reset(dataTransform);
      setSaleOrder(JSON.parse(localStorage.getItem('prevResponseFilter')));
      setIsSubmitingData(true);
      // onSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Recupera la lista de clientes
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Abril 2024
   */
  const getCustomers = () => {

    setCustomers({
      isLoading: true,
      isDisabled: true,
      data: []
    })
    usersService.getCustomerAssociatesByAN8(an8Logged).then((response) => {
      let customersResponse = response;

      setCustomers({
        isLoading: false,
        isDisabled: false,
        data: customersResponse
      });
    }).catch((error) => {
      console.log(error);
      setCustomers({
        isLoading: false,
        isDisabled: false,
        data: ['']
      });

      if (sessionDifference > Number(tokenExpired)) {
        sesionExpired(dispatch, history);
      } else {
        actionErrorConnection(error, 'Error al recuperar clientes.');
      }
    });
  }

  const handleChangeValue =(event, input) =>{

    const inputValue = event.target.value;
    const arrayValue = {...dataFilters, [input] : inputValue};

    setDataFilters(arrayValue);
    reset(arrayValue);
}

  /**
   * Crea el onjeto a enviar en la petición de busqueda
   * @param {object} data - información del formulario
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   */
  const onSubmit = (data) => {

    const element = document.getElementById('collapseExample');
    element.classList.remove('show');

    setSaleOrder([]);

    setIsLoadingData(true);
    setIsErrorResponse(false);

    let params = {}
    if (redirectLoad?.reloadFilters && isFirstLoad) {
      params = JSON.parse(localStorage.getItem('headerFilter'));
      setIsFirstLoad(false);
    } else {
      const startDate = selectStartDate ? selectStartDate : getValues().startDate;
      const endDate = selectEndDate ? selectEndDate : getValues().endDate;
      params = {
        an8: data.an8,
        startDate: convertDateToJulian(startDate),
        endDate: convertDateToJulian(endDate),
        typeOfReceipt:data.typeOfReceipt,
        series:data.series,
        startDateDefault: startDate,
        endDateDefault: endDate
      };
    }
    localStorage.removeItem('headerFilter');
    localStorage.setItem("headerFilter", JSON.stringify(params));

    getInvoiceByFilterService(params);

  };

  const getInvoiceByFilterService = (dataFilter) => {
    AdvancesInvoicesAndComplementsService.getInvoiceByFilters(dataFilter)
      .then((response) => {
        setIsLoadingData(false);
        setIsSubmitingData(true);
        if (response.message?.length > 2){
          setErrorResponse(response.message);
          setIsErrorResponse(true);
      } else{
        setSaleOrder(response.data);
        localStorage.setItem("prevResponseFilter", JSON.stringify(response.data));
        setIsErrorResponse(false);
      }
      })
      .catch((error) => {
        setIsSubmitingData(true);
        setIsLoadingData(false);
        if (error.response) {
          setErrorResponse(error.response.data.mensaje);
          if (sessionDifference > Number(tokenExpired)) {
            sesionExpired(dispatch, history);
          }
        } else {
          setErrorResponse(error);
        }
        setIsErrorResponse(true);
        actionErrorConnection(error, 'Error al recuperar información.');
      });

  }

  const columns = useMemo(
    () => [
      {
        Header: "Acciones",
        accessor: "actions",
        Cell: (propsCells) => {

          const rowIdx = propsCells.row.id;

          const downloadFile = (e, typeFile, id) => {

            const detailRow = saleOrderRef.current[id];

            const arrayPayment = {
                'date': detailRow.dateInvoice,
                'invoiceNumber': detailRow.invoiceNumber,
                'invoiceType': detailRow.typeDownload?.trim(),
                'format': typeFile
            };

            if (typeFile === 'pdf') {
              AdvancesInvoicesAndComplementsService.downloadPayment(arrayPayment).then(
                    (response) => {

                        const byteString = window.atob(response.data.split(',')[1]);
                        const mimeString = response.data.split(',')[0].split(':')[1].split(';')[0];

                        const ab = new ArrayBuffer(byteString.length);
                        const ia = new Uint8Array(ab);
                        for (let i = 0; i < byteString.length; i++) {
                            ia[i] = byteString.charCodeAt(i)
                        }

                        const dataBlob = new Blob([ab], { type: mimeString });

                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(dataBlob, `${response.name}.pdf`);
                            return
                        }

                        const url = window.URL.createObjectURL(dataBlob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `${response.name}.pdf`);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    },
                    (error) => {

                        if (error.response) {
                            console.log(error.response.data.message)
                            const message = error.response.data.message.split(':');
                            actionErrorConnection(error, `${message[1]}`);
                        } else {
                            actionErrorConnection(error, 'Error al descargar archivo PDF.');
                        }
                    });

                console.log('descargar archivo pdf');

            } else if (typeFile === 'xml') {
              AdvancesInvoicesAndComplementsService.downloadPayment(arrayPayment).then(
                    (response) => {
                        console.log('ok descarga');
                        const byteString = window.atob(response.data.split(',')[1]);
                        const mimeString = response.data.split(',')[0].split(':')[1].split(';')[0];

                        const ab = new ArrayBuffer(byteString.length);
                        const ia = new Uint8Array(ab);
                        for (let i = 0; i < byteString.length; i++) {
                            ia[i] = byteString.charCodeAt(i)
                        }

                        const dataBlob = new Blob([ab], { type: mimeString });

                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(dataBlob, `${response.name}.xml`);
                            return
                        }

                        const url = window.URL.createObjectURL(dataBlob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `${response.name}.xml`);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    },
                    (error) => {
                        actionErrorConnection(error, 'Error al descargar archivo xml.');
                    });
                console.log('descargar archivo xml');
            }
          };

          return (
            <div>
              <Tooltip title="Descargar PDF" placement="top-start" arrow>
                <button className="btn custom-btn-icons"
                  onClick={(e) => downloadFile(e, 'pdf', rowIdx)}
                >
                  <i className="fas fa-file-pdf mr-1"></i>
                </button>
              </Tooltip>
              <Tooltip title="Descargar XML" placement="top-start" arrow>
                <button className="btn custom-btn-icons"
                  onClick={(e) => downloadFile(e, 'xml', rowIdx)}
                >
                  <i className="fas fa-file-code"></i>
                </button>
              </Tooltip>
            </div>
          );
        },
      },
      {
        Header: 'Cliente',
        accessor: 'an8',
      },
      {
        Header: "Tipo",
        accessor: "type",
      },
      {
        Header: "Fecha factura",
        accessor: "dateInvoice",
      },
      {
        Header: "Serie",
        accessor: "serie",
      },
      {
        Header: "No. factura",
        accessor: "invoiceNumber",
        Cell: (propsCells) => {

          const rowIdx = propsCells.row.id;

          const viewDetail = (id) => {

            const detailRow = saleOrderRef.current[id];
            const detailToSend = {
              type: detailRow.type?.trim(),
              dateInvoice: detailRow.dateInvoice?.trim(),
              serie: detailRow.serie?.trim(),
              invoiceNumber: detailRow.invoiceNumber?.trim(),
              amountWithoutVat: detailRow.amountWithoutVat?.trim(),
              discountConcept: detailRow.discountConcept?.trim(),
              discountAmount: detailRow.discountAmount?.trim(),
              amountLessDiscount: detailRow.amountLessDiscount?.trim(),
              vat: detailRow.vat?.trim(),
              totalWithVat: detailRow.totalWithVat?.trim(),
              wayToPay: detailRow.wayToPay?.trim(),
              paymentMethod: detailRow.paymentMethod?.trim()
          }
            
            props.history.push({
              pathname: `/operation/advances-invoices-and-complements/detail/${detailRow.invoiceNumber}`,
              state: { dataHeader: detailToSend }
            });
            window.location.reload();
          };

          return (
            <div>
              <Tooltip title="Ver detalle" placement="top-start" arrow>
                <button className="btn custom-btn-icons"
                  onClick={() => viewDetail(rowIdx)}
                >
                  {saleOrderRef.current[rowIdx]?.invoiceNumber} <i className="fas fa-search mr-1"></i>
                </button>
              </Tooltip>
            </div>
          );
        },
      },
      {
        Header: "Monto sin IVA",
        accessor: "amountWithoutVat",
      },
      {
        Header: "Concepto descuento",
        accessor: "discountConcept",
      },
      {
        Header: "Monto descuento",
        accessor: "discountAmount",
      },
      {
        Header: "Monto menos descuento",
        accessor: "amountLessDiscount",
      },
      {
        Header: "IVA",
        accessor: "vat",
      },
      {
        Header: 'Total con IVA',
        accessor: 'totalWithVat'
      },
      {
        Header: "Forma pago",
        accessor: "wayToPay",
      },
      {
        Header: "Método pago",
        accessor: "paymentMethod",
      }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data: saleOrder,
  },
    useExpanded);
 
  const downloadFile = ()=>{
    const params = getValues()
    const an8 = params.an8
    const startDate = params.startDate
    const endDate = params.endDate
    setIsDownloadFile(true)
    const fileName = `consulta_facturas_${an8}_${startDate}-${endDate}`;
    AdvancesInvoicesAndComplementsService.downloadAdvancesInvoiceConsultationXlsx(saleOrder, an8).then((response)=>{
      const byteString = window.atob(response.split(',')[1]);
      const mimeString = response.split(',')[0].split(':')[1].split(';')[0];

      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      const dataBlob = new Blob([ab], { type: mimeString });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(dataBlob, `${fileName}.xls`);
        setIsDownloadFile(false);
        return
      }

      const url = window.URL.createObjectURL(dataBlob);
      const link = document.createElement('a');
      link.href = url
      link.setAttribute('download', `${fileName}.xls`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      setIsDownloadFile(false);
    },
    (error)=>{
      setIsDownloadFile(false);
      actionErrorConnection(error, 'Error al descargar archivo xls.');
    });
}
  return (
    <>
      <div className="container-fluid p-0 m-0">
        <div className="row flex-nowrap p-0 m-0">
          <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
            <SidebarMenu />
          </div>
          <div className="col p-0 ms-1 me-1">
            <NavTopMenu />
            <div className="container ps-3 pe-3 container-size">
              <div className="row base-container ">
                <div>
                  <div className="col-12 border-title text-title pt-2 pb-2 ps-4">
                    <span className="h4">Consulta de facturas</span>
                  </div>
                  <div className="col-12 pt-3 pb-3 ps-1 pe-1">
                    <div className="row ">
                      <div className="col-12 ">
                        <div className="w-100 d-flex justify-content-end">

                          {(customers.isLoading) &&
                            <Tooltip title="Cargando filtro..." placement="top-start" arrow>
                              <div className="custom-icon-loading me-1">
                                <i className="fas fa-spinner fa-spin"></i>
                              </div>
                            </Tooltip>
                          }
                          {
                            isDownloadFile ?
                              <Tooltip title="Descargargando..." placement="top-start" arrow>
                                <div className="custom-icon-loading me-1">
                                  <i className="fas fa-spinner fa-spin"></i>
                                </div>
                              </Tooltip>
                              :
                              <Tooltip title="Descargar resultados" placement="top-start" arrow>
                                <div>
                                  <button
                                    className="btn custom-btn-icons"
                                    onClick={()=>downloadFile()}
                                    type="button"
                                    disabled={isLoadingData || isErrorResponse }
                                  >
                                    <i className="fas fa-download"></i>
                                  </button>
                                </div>
                              </Tooltip>
                          }
                          <Tooltip title="Filtrar" placement="top-start" arrow>
                            <button className="btn custom-btn-icons"
                              type="button" data-bs-toggle="collapse"
                              data-bs-target="#collapseExample" aria-expanded="false"
                              aria-controls="collapseExample">
                              <i className="fas fa-filter"></i>
                            </button>
                          </Tooltip>
                        </div>
                        <div className="collapse show" id="collapseExample">
                          <div className="filter-continer">
                            <div className="container mt-3">
                              <form className="row">
                                <div className="col-md-5 col-lg-4 mb-3">
                                  <TextField
                                    select
                                    required
                                    id="an8"
                                    name="an8"
                                    label="Num. cliente"
                                    variant="outlined"
                                    size="small"
                                    disabled={customers.isDisabled || customers.isLoading}
                                    fullWidth
                                    value={dataFilters.an8}
                                    {...register('an8')}
                                    onChange={event => handleChangeValue(event, 'an8')}
                                  >
                                    <MenuItem value="">Seleccionar cliente</MenuItem>
                                    {customers.data.map(({ noCustomer, name }) => (
                                      <MenuItem key={noCustomer} value={noCustomer}>
                                        {noCustomer} - {name}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                  <MuiPickersUtilsProvider
                                    utils={DateFnsUtils}
                                    locale={esLocale}>
                                    <DatePicker
                                      disableToolbar
                                      autoOk
                                      fullWidth
                                      required
                                      control={control}
                                      id="startDate"
                                      name="startDate"
                                      inputVariant="outlined"
                                      variant="inline"
                                      label="Fecha de inicio"
                                      size="small"
                                      format="dd/LLLL/yyyy"
                                      value={selectStartDate}
                                      onChange={handleStartDateChange}
                                    />
                                  </MuiPickersUtilsProvider>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                  <MuiPickersUtilsProvider
                                    utils={DateFnsUtils}
                                    locale={esLocale}>
                                    <DatePicker
                                      disableToolbar
                                      autoOk
                                      fullWidth
                                      required
                                      control={control}
                                      id="endDate"
                                      name="endDate"
                                      inputVariant="outlined"
                                      variant="inline"
                                      label="Fecha de Fin"
                                      size="small"
                                      format="dd/LLLL/yyyy"
                                      minDate={selectStartDate}
                                      // maxDate={dateMax}
                                      minDateMessage="La fecha debe ser mayor a la de inicio"
                                      value={selectEndDate}
                                      onChange={handleEndDateChange}
                                    />
                                  </MuiPickersUtilsProvider>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                  <TextField
                                    className="w-100"
                                    id="typeOfReceipt"
                                    name="typeOfReceipt"
                                    label="Tipo de comprobante"
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={dataFilters.typeOfReceipt}
                                    {...register('typeOfReceipt')}
                                    onChange={event => handleChangeValue(event, 'typeOfReceipt')}
                                  />
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                  <TextField
                                    className="w-100"
                                    id="series"
                                    name="series"
                                    label="Serie"
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={dataFilters.series}
                                    {...register('series')}
                                    onChange={event => handleChangeValue(event, 'series')}
                                  />
                                </div>
                                <div className="col-12 w-100 d-flex justify-content-end">
                                  <Tooltip title={(!selectStartDate || !selectEndDate) ? "Completar filtros obligatorios" : "Buscar"} placement="top-start" arrow>
                                    <div>
                                      <button
                                        className="ms-2 mb-3 btn custom-btn"
                                        disabled={isLoadingData || !selectStartDate || !selectEndDate}
                                        onClick={handleSubmit(onSubmit)}
                                        type='submit'
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseExample"
                                        aria-expanded="false"
                                        aria-controls="collapseExample"
                                      >
                                        <i className="fas fa-search"></i>
                                      </button>
                                    </div>
                                  </Tooltip>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="w-100 d-flex justify-content-end">

                        </div>

                        <div className='table-wrap'>
                          <table
                            className="table-order"
                            {...getTableProps()}
                          >
                            <thead>
                              {headerGroups.map((headerGroup, i) => (
                                <tr {...headerGroup.getHeaderGroupProps()} className="border-content sticky-header" key={i}>
                                  {headerGroup.headers.map((column, j) => (
                                    <th {...column.getHeaderProps()}
                                      className="border-element header-element header-text pt-3 pb-3" key={j}>
                                      {column.render("Header")}
                                    </th>
                                  ))}
                                </tr>
                              ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                              {rows.map((row) => {
                                prepareRow(row);
                                return (
                                  <React.Fragment key={row.getRowProps().key}>
                                    <tr className="element-row border-content">
                                      {row.cells.map((cell, i) => {
                                        return (
                                          <td className="border-element content-text pt-2 pb-2"
                                            {...cell.getCellProps()}
                                            key={i}>
                                            {
                                              cell.column.id === 'an8' ?
                                                getValues().an8
                                                : ((cell.column.Header === 'Monto sin IVA' || cell.column.Header === 'Monto descuento' || cell.column.Header === 'Monto menos descuento' || cell.column.Header === 'IVA' || cell.column.Header === 'Total con IVA') ?
                                                (cell.value && cell.value !== '' && cell.value !== ' ' ?
                                                 `$ ${parseFloat(cell.value).toLocaleString(currencySelected, {
                                                      minimumFractionDigits: 2
                                                  })}` 
                                                  : '') : cell.render("Cell"))
                                            }
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  </React.Fragment>
                                );
                              })}
                            </tbody>
                          </table>
                          {(isErrorResponse) &&
                            <div className="error-message border-content pt-4 pb-4">
                              <span className="">Error: {errorResponse && errorResponse.toString()}</span>
                            </div>}
                          {(isLoadingData) &&
                            <div className="border-content pt-4 pb-4 custom-icon-loading">
                              <i className="fas fa-spinner fa-spin"></i>
                            </div>}
                          {(saleOrder.length === 0 && !isLoadingData && !isErrorResponse && isSubmitingData) &&
                            <div className="element-row-message border-content pt-4 pb-4 ">
                              <span>Los filtros seleccionanos no devolvieron coincidencias.</span>
                            </div>}
                          {
                            (!isSubmitingData && !isLoadingData && !isErrorResponse) &&
                            <div className="element-row-message border-content pt-4 pb-4">
                              <span>Ejecute una búsqueda para obtener resultados.</span>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

AdvancesInvoicesAndComplementsScreen.propTypes = {
  row: PropTypes.any,
  getToggleAllRowsSelectedProps: PropTypes.any,
  history: PropTypes.object
};